<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/myAccountList/">My Accounts</a></li>
      <li class="breadcrumb-item active" aria-current="page">View API</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <div class="text-right float-right">
        <button (click)="editApiDetails()" class="btn btn-orange ml-2">Edit API</button>
      </div>
    </div>
  </div>
  <form>
    <div class="row mt-2">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black"><b>API Details</b></h2>
          <div class="row mt-3">
            <div class="col-6">
              <label class="text-black"><b>API Name</b> : {{viewData?.apiName}}</label>
            </div>
            <div class="col-6">
              <label class="text-black"><b>API Key</b> : {{viewData?.apiKey}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <label class="text-black"><b>Secret Key</b> : {{viewData?.secretKey}}</label>
            </div>
            <div class="col-6">
              <label class="text-black"><b>URL</b> : {{viewData?.redirectUrl}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-6">
        <div class="inner-box mt-3"  *ngFor="let notification of openList | slice:0: sliceUPto(openList?.length)">
          <table class="table" >
            <thead>
            <tr>
              <th>{{notification.groupName}}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let n of notification?.apiSettingsResponses">
              <td width="25%">
                <div class="toggle-2">
                  <input type="checkbox" name="onoffswitch" id="{{n.typeName}}" class="custom-control-input" [ngModel]="n.enabled" disabled [ngModelOptions]="{standalone: true}" class="checkbox"/>
                  <label for="{{n.typeName}}" class="toggle">
                    <span>ON</span><span>OFF</span>
                  </label>
                </div>
              </td>
              <td>{{n?.typeName}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-6">
        <div class="inner-box mt-3"  *ngFor="let notification of openList | slice:sliceUPto(openList?.length):openList?.length">
          <table class="table" >
            <thead>
            <tr>
              <th>{{notification.groupName}}</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let n of notification?.apiSettingsResponses">
              <td width="25%">
                <div class="toggle-2">
                  <input type="checkbox" name="onoffswitch" id="c-{{n.typeName}}" class="custom-control-input" [ngModel]="n.enabled" [ngModelOptions]="{standalone: true}" disabled class="checkbox"/>
                  <label for="c-{{n.typeName}}" class="toggle">
                    <span>ON</span><span>OFF</span>
                  </label>
                </div>
              </td>
              <td>{{n?.typeName}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </form>
</section>

<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/myAccountList" class="btn btn-cancel">Close</button>
    </div>
  </div>
</div>
